export default __webpack_public_path__ + "static/contrade-website-98a981a12ce7dfc831536b2a239658a3.jpg";